module.exports = __webpack_public_path__ + "static/media/augmint.d9cb8788.svg";